"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var ComparisonInput = function (_a) {
    var value = _a.value, usePercentage = _a.usePercentage, disableAutofocus = _a.disableAutofocus, onValueChange = _a.onValueChange, onEnterKeyPress = _a.onEnterKeyPress, separators = _a.separators;
    return (react_1.default.createElement(sdk_ui_kit_1.InputWithNumberFormat, { className: "s-mvf-comparison-value-input", value: value, onEnterKeyPress: onEnterKeyPress, onChange: onValueChange, isSmall: true, autofocus: !disableAutofocus, suffix: usePercentage ? "%" : "", separators: separators }));
};
exports.default = ComparisonInput;
//# sourceMappingURL=ComparisonInput.js.map